import isResumingInquiry from './isResumingInquiry'

const shouldGetSessionToken = (
  application: any,
  isIdvReferral: boolean
): boolean => {
  const isResuming = isResumingInquiry(
    application.vehicleType,
    application.identityInquiryId,
    application.identityVerificationStatus,
    application.identityTemplateId,
    isIdvReferral,
    application.country
  )

  return isResuming
}

export default shouldGetSessionToken
